import { useState } from "react";
import notrelevant from "../../assets/shapes_svg/feed/notrelevant.svg";
import save from "../../assets/shapes_svg/course/save.svg";
import FeedsCarousel from "../FeedCarousels";
import "react-multi-carousel-18/lib/styles.css";
import ArticlePopup from "../ArticlePopUp";

const FeedRow = ({ title, feeds, handleDelete, feedsLike, src }) => {
  const [selectedArticle, setSelectedArticle] = useState(null);

  const handleArticleClick = (feed) => {
    setSelectedArticle(feed);
  };
  const closePopup = () => {
    setSelectedArticle(null);
  };
  const renderFeedItem = (feed) => (
    <div
      key={feed.id}
      className="feed_rowitem"
      style={{ width: "300px", margin: "0 10px", cursor: "pointer" }}
      onClick={() => handleArticleClick(feed)}
    >
      <img
        src={save}
        alt=""
        style={{
          position: "absolute",
          left: "-2%",
          top: "-2%",
          opacity: feedsLike && feedsLike.includes(feed.id) ? "1" : "0.5",
        }}
      />
      <img
        src={notrelevant}
        alt=""
        style={{ position: "absolute", right: "-2%", top: "-2%" }}
        onClick={(e) => {
          e.stopPropagation();
          handleDelete(feed.id);
        }}
      />
      <h5>{feed.title.substring(0, 50)}...</h5>
    </div>
  );

  return (
    <div className="feed__row mb-3 d-flex">
      <div
        className="feed__rowtitle pt-3 d-flex flex-column"
        style={{
          alignItems: "center",
          width: "200px",
        }}
      >
        <h4
          className="mx-auto"
          style={{
            width: "fit-content",
            textAlign: "center",
            color: "#F2F8F0",
            marginBottom: "32px",
          }}
        >
          {title}
        </h4>
        <img src={src} alt="Feed Icons" width={90} />
      </div>
      <div className="feed__rowitems ms-4 flex-grow-1">
        {feeds && feeds.length > 0 && (
          <FeedsCarousel feeds={feeds}>
            {feeds.map(renderFeedItem)}
          </FeedsCarousel>
        )}
      </div>
      <ArticlePopup article={selectedArticle} onClose={closePopup} />
    </div>
  );
};

export default FeedRow;
